import { render, staticRenderFns } from "./WcFormsLinkItem.vue?vue&type=template&id=73aa6a04&lang=pug&"
import script from "./WcFormsLinkItem.vue?vue&type=script&lang=js&"
export * from "./WcFormsLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports